import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Forgot.css";
import { Mail, Check, ArrowRight } from "lucide-react";

const Forgot = () => {
    const [email, setEmail] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Reset password link sent to:", email);
    };

    return (
        <div className="forgot-page">
            <div className="forgot-container">

                {/* LEFT PANEL */}
                <div className="forgot-left">
                    <div className="logo-container">
                        <svg className="product-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <path d="M 20 35 L 45 35" stroke="#1E40AF" strokeWidth="4" strokeLinecap="round"></path>
                            <path d="M 20 50 L 55 50" stroke="#14B8A6" strokeWidth="4" strokeLinecap="round"></path>
                            <path d="M 20 65 L 65 65" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round"></path>
                            <path d="M 45 35 L 55 40 L 45 45 Z" fill="#1E40AF"></path>
                            <path d="M 55 50 L 65 55 L 55 60 Z" fill="#14B8A6"></path>
                            <path d="M 65 65 L 75 70 L 65 75 Z" fill="#F59E0B"></path>
                            <circle cx="80" cy="50" r="8" fill="#1E40AF"></circle>
                        </svg>
                        <span className="logo-text">SequFlow</span>
                    </div>

                    <div className="hero-text">
                        <h1>Forgot your password?</h1>
                        <p>
                            No worries! Enter your email and we'll send you a reset link
                            to get back into your account.
                        </p>
                    </div>

                    <div className="recovery-section">
                        <h4 className="recovery-title">Account Recovery</h4>

                        <div className="recovery-item">
                            <div className="recovery-bar-container">
                                <div className="recovery-bar bar-long"></div>
                                <div className="recovery-bar bar-short"></div>
                            </div>
                            <ArrowRight className="recovery-arrow" size={14} />
                        </div>

                        <div className="recovery-item">
                            <div className="recovery-bar-container">
                                <div className="recovery-bar bar-medium"></div>
                                <div className="recovery-bar bar-very-short"></div>
                            </div>
                            <ArrowRight className="recovery-arrow" size={14} />
                        </div>

                        <div className="recovery-item">
                            <div className="recovery-bar-container">
                                <div className="recovery-bar bar-full highlight"></div>
                            </div>
                            <Check className="recovery-check" size={14} />
                        </div>

                        <h4 className="recovery-title second-title">Account Recovery</h4>

                        <div className="recovery-item">
                            <div className="recovery-bar-container">
                                <div className="recovery-bar bar-short"></div>
                                <div className="recovery-bar bar-long highlight"></div>
                                <div className="recovery-bar bar-medium"></div>
                                <div className="recovery-bar bar-short"></div>
                            </div>
                            <ArrowRight className="recovery-arrow" size={14} />
                        </div>

                    </div>

                    <div className="particles-container">
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className="particle"></div>
                        ))}
                    </div>

                </div>

                {/* RIGHT PANEL */}
                <div className="forgot-right">

                    <div className="form-box">

                        <h2>Forgot Password</h2>
                        <p className="form-subtitle">
                            Enter your email address and we'll send you a <b>reset link</b>.
                        </p>

                        <form onSubmit={handleSubmit}>

                            <label className="input-label">Email Address</label>

                            <div className="input-wrapper">
                                <Mail className="input-icon" size={18} />
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <button className="reset-btn">
                                Send Reset Link
                            </button>

                        </form>

                        <div className="back-login">
                            Back to <Link to="/login">Sign In</Link>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    );
};

export default Forgot;
